// ------------------------------------------------------------
// TagService.ts – helper to fetch tag lists
// ------------------------------------------------------------
import api from "../../services/api";
export const fetchTags = async (type: string) => {
  const { data } = await api.get(`/dietary-tags`, { params: { type } });
  return data as { tag_id: number; tag_name: string; type: string }[];
};